export const LENDER_LIST_COLUMN_COUNT = 3;
export const MAX_SELECTED_OPTIONS_FOR_LENDER_LIST = 6;
